(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takoo-featured-five"] && !Shopify.designMode) return;
  try {
    
function cardClearanceShift(launcher, targets, previousShift, viewportHeight, open) {
  if (open || !launcher.width || !launcher.height) return 0;
  const baseBottom = launcher.bottom - previousShift;
  let bottom = baseBottom;
  const visibleTargets = targets.filter(r => r.width && r.height && r.bottom > 0 && r.top < viewportHeight)
    .sort((a, b) => b.top - a.top);
  for (const r of visibleTargets) {
    if (launcher.left < r.right && launcher.right > r.left &&
        bottom > r.top - 12 && bottom - launcher.height < r.bottom + 12) {
      bottom = r.top - 12;
    }
  }
  return Math.min(0, Math.max(launcher.height + 12, bottom) - baseBottom);
}

if (typeof document !== 'undefined' && document.querySelector('.takoo-focus')) {
  const html = document.documentElement;
  html.classList.add('takoo-focus-clearance');
  let shift = 0;
  let queued = false;
  const observed = new WeakSet();
  const observer = new MutationObserver(schedule);
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  function sync() {
    queued = false;
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    const runtime = root?.querySelector('shopify-agent-runtime');
    for (const scope of [root, runtime?.shadowRoot]) {
      if (scope && !observed.has(scope)) {
        observed.add(scope);
        observer.observe(scope, {childList:true, subtree:true, attributes:true, attributeFilter:['open','aria-expanded']});
      }
    }
    const launcher = root?.querySelector('[part="activator"]') || runtime?.shadowRoot?.querySelector('[part="activator"]');
    if (!launcher) return;
    const open = Boolean(runtime?.hasAttribute('open') || launcher.getAttribute('aria-expanded') === 'true');
    const targets = [...document.querySelectorAll('.takoo-focus .takoo-focus__cta')]
      .filter(el => {
        const style = getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }).map(el => el.getBoundingClientRect());
    shift = cardClearanceShift(launcher.getBoundingClientRect(), targets, shift, innerHeight, open);
    html.style.setProperty('--takoo-focus-chat-shift', shift + 'px');
  }
  window.addEventListener('scroll', schedule, {passive:true, capture:true});
  window.addEventListener('resize', schedule, {passive:true});
  for (const event of ['click','transitionend','shopify:section:load','shopify:section:unload']) {
    document.addEventListener(event, schedule);
  }
  observer.observe(document.body, {childList:true, subtree:true});
  customElements.whenDefined('shopify-chat').then(schedule);
  customElements.whenDefined('shopify-agent-runtime').then(schedule);
  schedule();
}

  } catch(e) { console.error(e); }
})();
})();
